import { Box } from '@mui/system'
import { observer } from 'mobx-react-lite'
import moment from 'moment'
import React, { FC, useEffect } from 'react'
import DataUnit from '../../../../../components/customElements/DataUnit/DataUnit'
import NewCustomAccordion from '../../../../../components/customElements/RequestDataAccordions/utils/NewCustomAccordion'
import { formatPhoneNumber } from '../../../../../helpers/ordersUtiles'
import { ActiveOrder } from '../types/NewDrawers.types'
import { getHeadTitle, wrapperSx } from '../utils/service-drawer-element.utils'

export type Variant = 'opened' | 'closed'

interface INewServiceDrawerElementProps {
  el: ActiveOrder
  serialNumber: string
  defaultOpenedIndex: number
  checkedIndex: number
  onCheck: () => void
  index: number
  variant: Variant
  openedAccordionIndex: number
  setOpenedAccordionIndex: (index: number) => void
}

const NewServiceDrawerElement: FC<INewServiceDrawerElementProps> = ({
  el,
  serialNumber,
  checkedIndex,
  defaultOpenedIndex,
  onCheck,
  index,
  variant,
  openedAccordionIndex,
  setOpenedAccordionIndex,
}) => {
  const markSearchText = (str: string, _field: string) => {
    return <span style={{ background: 'yellow' }}>{str}</span>
  }

  useEffect(() => {
    if (defaultOpenedIndex === index) {
      setOpenedAccordionIndex(index)
    }
  }, [defaultOpenedIndex])

  const headColor =
    variant === 'opened' ? 'rgba(224, 23, 23, 0.15)' : 'rgba(224, 223, 223, 1)'

  return (
    <NewCustomAccordion
      index={index}
      openIndex={openedAccordionIndex}
      setOpenIndex={setOpenedAccordionIndex}
      checked={el.requestId === checkedIndex}
      onCheck={onCheck}
      withCheckbox
      headTitle={getHeadTitle(el, variant)}
      headColor={headColor}
    >
      <Box sx={wrapperSx}>
        <DataUnit
          name='S/N Оборудования'
          value={markSearchText(serialNumber, 'serialNumber')}
        />
        <DataUnit name='№ заявки в Сервис-центре' value={el.requestId} />
        <DataUnit
          name='Дата обращения'
          value={
            el.requestDate ? moment(el.requestDate).format('DD.MM.YYYY') : '-'
          }
        />
        <DataUnit name='Телефон' value={formatPhoneNumber(el.phone, true)} />
        <DataUnit name='Неисправность' value={el.malfunction.name} />
      </Box>
    </NewCustomAccordion>
  )
}

export default observer(NewServiceDrawerElement)
